export default __webpack_public_path__ + "static/media/vegetable_oil.5a114154.png";